<app-unification-animation></app-unification-animation>
<div class="body-loading">
    <div class="message-loader"></div>
    <div class="icon">
        <i class="fad fa-circle-notch fa-spin"></i>
    </div>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col">
            <app-guanabara-header></app-guanabara-header>
            <router-outlet></router-outlet>
            <app-guanabara-footer></app-guanabara-footer>
        </div>
    </div>
</div>
<whatsapp-link *ngIf="showWpp" ></whatsapp-link>
<ng-container *ngIf="configService.config.googleTagManagerActive">
    <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PMCP85K" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
</ng-container>
<!-- 
<div class="container">
 <img src="https://ecommerce-cdn-prod.gipsyy.com/ecommerce/imgs/common-guanabara/Modal.png" style="margin: auto; width: 100%;">
</div> -->